






























import { Component, Vue } from "vue-property-decorator";
import { i18n } from "@/resources/locales";

@Component
export default class ActiveSpaceView extends Vue {
  loading = true;
  success = true;
  errorText = "";
  mounted() {
    const token = this.$route.query.token;
    if (token)
      this.$store.dispatch("SpaceStore/activeSpaceAction", {
        token: token,
        callback: (response) => {
          this.loading = false;
          if (response.data.status === "KO") {
            this.success = false;
            this.errorText = i18n
              .t(`notifications.apiMessage.${response.data.code}`)
              .toString();
          } else {
            this.$router.push("/").catch(() => {});
            setTimeout(() => {
              location.reload();
            }, 1000);
          }
        },
        callbackError: () => {
          this.loading = false;
          this.success = false;
          this.errorText = i18n
            .t("notifications.genericError.activeSpace")
            .toString();
        },
      });
    else this.$router.push("auth/login");
  }
  backToLogin() {
    this.$router.push("auth/login");
  }
}
